<template>
  <section>
    <r-title>{{ $t("title") | titlecase }}</r-title>

    <ProcessStepBox
      :step="1"
      :active-step="step"
      :loading="!branches"
      :selectable="branchSelectable"
      :title="$t('branches.title') | titlecase"
      @click="toStep(1)"
    >
      <p v-if="!branches">{{ $t("branches.is-loading") }}</p>
      <template v-else-if="branches.length">
        <p>{{ $t("branches.prompt") }}</p>
        <BranchSelect v-model="branch" :branches="branches" />
      </template>
      <p v-else>{{ $t("branches.is-empty") }}</p>

      <div class="buttons">
        <r-button :disabled="!branchReady" prominent @click.stop="toStep(2)">
          {{ $t(".glossary.button.continue") }}
        </r-button>
      </div>
    </ProcessStepBox>

    <ProcessStepBox
      :step="2"
      :active-step="step"
      :loading="branchReady && !showUsers"
      :selectable="branchReady"
      :title="$t('users.title') | titlecase"
      @click="toStep(2)"
    >
      <p v-if="!branchReady">{{ $t("branches.is-not-selected") }}</p>
      <p v-else-if="!showUsers">
        {{ $t("users.is-loading", { branch: branch.name }) }}
      </p>
      <template v-else>
        <p>{{ $t("users.caption", { branch: branch.name }) }}</p>
        <table v-if="showUsers.length" class="table is-fullwidth">
          <thead>
            <tr>
              <th>{{ $t(".user.login") | titlecase }}</th>
              <th>{{ $t(".user.name") | titlecase }}</th>
              <th>{{ $t(".user.email") | titlecase }}</th>
              <th>{{ $t(".user.password") | titlecase }}</th>
              <th />
            </tr>
          </thead>
          <tbody>
            <UserEditRow
              v-for="row in showUsers"
              :key="row.data.loginName"
              v-model="row.data"
              :branch="branch"
              :new="row.isNew"
              @locked="lockedRowsCount++"
              @unlocked="lockedRowsCount--"
              @remove="removeRow(row.data.loginName)"
            />
          </tbody>
        </table>
        <p v-else>
          {{ $t("users.is-empty", { branch: branch.name }) }}
        </p>
        <div class="buttons">
          <r-button :prominent="!showUsers.length" @click="addNewUser">
            {{ $t("users.button.new") }}
          </r-button>
        </div>
      </template>
    </ProcessStepBox>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

import { ProcessStepBox } from "@apphq/vue-base-components";

import BranchSelect from "@/components/BranchSelect.vue";
import UserEditRow from "@/components/UserEditRow.vue";

export default {
  name: "UserAdminPage",
  components: {
    ProcessStepBox,
    BranchSelect,
    UserEditRow
  },
  i18nOptions: {
    keyPrefix: "views.user-admin"
  },
  data() {
    return {
      step: 1,
      branch: null,
      showUsers: null,
      lockedRowsCount: 0,
      loginNameGenerator: 0
    };
  },
  computed: {
    branchSelectable() {
      return !this.lockedRowsCount;
    },
    branchReady() {
      return Boolean(this.branch);
    },
    users() {
      const users = this.branch && this.$store.getters.users(this.branch.name);
      if (users) {
        return users.map(user => ({ data: user }));
      }
      return users;
    },
    ...mapGetters(["branches"])
  },
  watch: {
    branch(branch) {
      this.$store.dispatch("loadUsers", branch);
    },
    users(users) {
      this.showUsers = [
        ...(users || []),
        ...(this.showUsers || []).filter(user => user.isNew)
      ];
    }
  },
  beforeCreate() {
    this.$store.dispatch("loadBranches");
  },
  methods: {
    toStep(step) {
      if (
        (step === 1 && !this.branchSelectable) ||
        (step === 2 && !this.branchReady)
      ) {
        return;
      }
      this.step = step;
    },
    addNewUser() {
      const user = {
        data: {
          loginName: this.loginNameGenerator,
          firstName: "",
          lastName: "",
          email: ""
        },
        isNew: true
      };
      this.showUsers.push(user);

      this.loginNameGenerator++;
    },
    removeRow(loginName) {
      this.showUsers = this.showUsers.filter(
        row => row.data.loginName != loginName
      );
    }
  }
};
</script>
